import script from "./BusinessRowMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./BusinessRowMenu.vue?vue&type=script&setup=true&lang=ts"

import "./BusinessRowMenu.vue?vue&type=style&index=0&id=7652e8d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7652e8d6"]])

export default __exports__